import { map, isEmpty } from "lodash"
import PropTypes from "prop-types"
import { COMPOSITE } from "../shapes"
import Composite from "./item"

export default function CompositeList({ account, modelId, type, composites, openCompositeSecurity }) {
  if (isEmpty(composites)) {
    return <h5>No matching Indexes or ETFs found</h5>
  }

  return <ol className={`composites ${type}`}>
    <li>
      <div className="ticker" />
      <div className="name" />
      <div className="correlation">Exposure</div>
    </li>
    {map(composites, (composite) => <Composite
      key={composite.id}
      {...{
        account,
        modelId,
        openCompositeSecurity,
        composite,
      }}
    />)}
  </ol>
}

CompositeList.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["positive", "negative"]).isRequired,
  composites: PropTypes.arrayOf(COMPOSITE).isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
}
